import { useEffect, useState } from 'react';

const COARSE_POINTER_QUERY = '(pointer: coarse)';

/**
 * Reports whether the device's PRIMARY pointer is coarse (touchscreen phones/tablets).
 *
 * Uses `matchMedia('(pointer: coarse)')` rather than `navigator.maxTouchPoints > 0`:
 * the latter is true on trackpad and touchscreen laptops, which are mouse-primary,
 * and would wrongly route them through touch-only UI code paths.
 */
export const useIsTouchDevice = () => {
  const [isTouchDevice, setIsTouchDevice] = useState(
    () =>
      typeof window !== 'undefined' &&
      typeof window.matchMedia === 'function' &&
      window.matchMedia(COARSE_POINTER_QUERY).matches
  );

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;

    const mediaQuery = window.matchMedia(COARSE_POINTER_QUERY);
    const update = () => setIsTouchDevice(mediaQuery.matches);

    update();
    mediaQuery.addEventListener('change', update);

    return () => mediaQuery.removeEventListener('change', update);
  }, []);

  return isTouchDevice;
};
